import {
    Component, EventEmitter, Input, Output
} from '@angular/core';
import { DeliveryStepsService } from '../../services/delivery-steps.service';
import { AddressModel } from '../../../shared/models/address.model';
import { AuthenticatedUserRepositoryService } from '../../services/authenticated-user-repository.service';

@Component({
    selector: 'payment-delivery-addresses',
    templateUrl: './payment.delivery.addresses.component.html',
    styleUrls: ['../../payment.component.scss']
})
export class PaymentDeliveryAddressesComponent {
    public inputtedZipCode = '';
    public hasSelectedAddress = false;
    public selectedAddress: AddressModel;
    @Input() addresses = [];
    @Input() identificationReady = false;
    @Output() ready: EventEmitter<AddressModel> = new EventEmitter();

    constructor(
        protected deliverySteps: DeliveryStepsService,
        protected authenticatedUserService: AuthenticatedUserRepositoryService
    ) {
        this.authenticatedUserService.resetedUser$.subscribe(() => {
            this.hasSelectedAddress = false;
            this.selectedAddress = null;
            this.inputtedZipCode = '';
        });
        this.deliverySteps.resetedSelectedAddress$.subscribe(() => {
            this.hasSelectedAddress = false;
            this.selectedAddress = null;
        });
        if (this.deliverySteps.inputtedZipCode !== null) {
            this.inputtedZipCode = this.deliverySteps.inputtedZipCode;
        }
    }

    /**
     * This update current selected address from service and emit address
     * was selected event.
     **/
    public updateSelectedAddressValues(): void {
        this.hasSelectedAddress = this.deliverySteps.hasSelectedAddress();
        this.selectedAddress = this.deliverySteps.getSelectedAddress();
        this.ready.emit(this.selectedAddress);
    }
    /**
     * zipCodeInputted event listener.
     **/
    public onZipCodeInputted(zipCode) {
        this.inputtedZipCode = zipCode;
    }
    /**
     * selectedAddress event listener.
     **/
    public onSelectedAddress(address: AddressModel) {
        this.deliverySteps.setSelectedAddress(address);
        this.updateSelectedAddressValues();
    }
    /**
     * Return true if zip code was inputted.
     **/
    public hasInputtedZipCode() {
        return this.inputtedZipCode !== '';
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/delivery/addresses/payment.delivery.addresses.component.ts